import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { registerListNumbering } from './listNumbering';

/** Hierarchical (`1.1`, `1.2.1`) numbering for numbered lists; the toolbar's list menu switches it. */
export const ListNumberingPlugin = () => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => registerListNumbering(editor), [editor]);
  return null;
};
